import { Events } from './events'
import allPermissions from './raws/allPermissions.json'

class PermissionsManager {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    PermissionsManager.insertPermissionsStyle([])
    PermissionsManager.loadPermissions()
    Events.handleEvent('app_data_updated', PermissionsManager.loadPermissions)
    Events.handleEvent('login_done', PermissionsManager.loadPermissions)
    Events.handleEvent('registration_done', PermissionsManager.loadPermissions)
    Events.handleEvent('logout_done', PermissionsManager.loadPermissions)
  }

  static async loadPermissions() {
    console.log('will load permissions')
    let permissions = await Events.sendDataRequestResolve(
      'permissions',
      {},
      2000,
    )
    permissions = permissions?.metaData?.permissions
    permissions ||= []
    PermissionsManager.insertPermissionsStyle(permissions)
  }

  static insertPermissionsStyle(permissions) {
    const css = PermissionsManager.generatePersmissionsCss(permissions)
    PermissionsManager.insertOrUpdateCSS(css)
  }

  static generatePersmissionsCss(permissions) {
    let css = `[permission] {display: none; --visible-display:block} [permission-click] {pointer-events: none;} [permission=none] {display: var(--visible-display);}`
    permissions.forEach(permission => {
      const escapedPermission = permission.replace(/:/g, '\\:')
      css += `[permission=${escapedPermission}] {display: var(--visible-display);} [permission-click=${escapedPermission}] {pointer-events: all;}`
    })
    return css
  }

  static insertOrUpdateCSS(cssContent) {
    let styleElement = document.getElementById('dynamic-permissions-style')

    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'dynamic-permissions-style'
      document.head.appendChild(styleElement)
    }

    styleElement.innerHTML = cssContent
  }

  static getMainPermissions(permissions) {
    const mainPermissions = new Set()

    permissions.forEach(permission => {
      const mainPermission = permission.split(':')[0]
      mainPermissions.add(mainPermission)
    })

    return Array.from(mainPermissions)
  }

  static getAllPermissions() {
    return allPermissions
  }
}

export { PermissionsManager }
